export default {
  en: {
    titleLineOne: 'Create a ClassForKids System',
    titleLineTwo: '',
    subtitle: '',
    suggestionLineOne: 'We suggest no more than a couple of words.',
    suggestionLineTwo: 'Something familiar and simple for you and your customers to easily remember.',
  },
};
